export enum UserSurveyResponseStatus {
  Completed = 1,
  Dismissed = 2,
}
